'use strict';
const mmWidgets = require('../widgets/mm-widgets');

mmWidgets.fn.nodeThemeStyleColorPicker = function (nodeStyle, mapThemeModel, colorPickerModel) {
	return mmWidgets.each(this, function () {
		const widget = this,
			themeAttrPath = widget.attr('data-mm-theme-color').split('.'),
			setup = () => {
				const color = mapThemeModel.getThemeAttribute(['node'], [nodeStyle, 'default'], themeAttrPath);
				widget.css('background-color', color);
			};
		setup();
		mapThemeModel.addEventListener('themeJSONChanged', setup);
		widget.click(() => {
			colorPickerModel.pickColor()
			.then(color => {
				mapThemeModel.overrideThemeAttribute(['node', nodeStyle].concat(themeAttrPath), color || undefined);
			})
			.catch(() => {});
		});
	});

};
mmWidgets.fn.nodeThemeStyleEditorWidget = function (params) {
	const {nodeStyle, description, mapThemeModel, colorPickerModel, fontPickerModel} = params;
	if (!nodeStyle || !description || !mapThemeModel || !colorPickerModel || !fontPickerModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const widget = this,
			colorPickers = widget.find('[data-mm-theme-color]'),
			fontPickers = widget.find('[data-mm-theme-font]'),
			fontSizers = widget.find('[data-mm-font-size]'),
			borderSizers = widget.find('[data-mm-border-size]'),
			cornerRadiusSizers = widget.find('[data-mm-corner-radius]'),
			nodeWidthSizers = widget.find('[data-mm-node-width]');
		widget.find('[data-mm-role="description"]').text(description);
		colorPickers.nodeThemeStyleColorPicker(nodeStyle, mapThemeModel, colorPickerModel);

		fontPickers.attr('data-mm-theme-node-style', nodeStyle).themeStyleFontPicker(mapThemeModel, fontPickerModel);
		fontSizers.attr('data-mm-theme-node-style', nodeStyle).themeStyleFontSizeWidget(mapThemeModel);
		borderSizers.attr('data-mm-theme-border-size', nodeStyle).themeStyleBorderSizeWidget(mapThemeModel);
		cornerRadiusSizers.attr('data-mm-theme-corner-radius', nodeStyle).themeStyleCornerRadiusWidget(mapThemeModel);
		nodeWidthSizers.attr('data-mm-theme-node-width', nodeStyle).themeStyleNodeWidthWidget(mapThemeModel);

	});
};


mmWidgets.fn.nodeThemeEditorWidget = function (params) {
	return mmWidgets.each(this, function () {
		const container = this,
			{mapThemeModel} = params,
			template = container.find('[data-mm-role~="theme-style-template"]').detach(),
			setupWidgets = () => {
				const levels = mapThemeModel.getLevels();
				container.empty();
				Object.keys(levels).forEach(level => {
					const row = template.clone();
					row.appendTo(container);
					row.nodeThemeStyleEditorWidget(Object.assign({nodeStyle: level, description: levels[level]}, params));
				});
			};
		setupWidgets();
		mapThemeModel.addEventListener('levelAdded themeChanged', setupWidgets);
	});
};
